{
  "name": "client-app",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "prestart": "node scripts/write-runtime-config.js",
    "start": "ng serve",
    "prebuild": "node scripts/write-runtime-config.js",
    "build": "ng build",
    "prebuild-prod": "node scripts/write-runtime-config.js",
    "build-prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.15",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.15",
    "@angular/compiler": "^19.2.15",
    "@angular/core": "^19.2.15",
    "@angular/forms": "^19.2.15",
    "@angular/material": "^19.2.15",
    "@angular/material-moment-adapter": "^19.2.15",
    "@angular/platform-browser": "^19.2.15",
    "@angular/platform-browser-dynamic": "^19.2.15",
    "@angular/router": "^19.2.15",
    "@angular/service-worker": "^19.2.15",
    "@ngx-translate/core": "16.0.4",
    "@syncfusion/ej2-angular-documenteditor": "~30.2.6",
    "@syncfusion/ej2-angular-richtexteditor": "~30.2.6",
    "@syncfusion/ej2-angular-spreadsheet": "~30.2.6",
    "@syncfusion/ej2-locale": "^34.2.2",
    "angularx-qrcode": "^19.0.0",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "cropperjs": "^1.6.2",
    "current-week-number": "^1.0.7",
    "jspdf": "^4.2.1",
    "moment": "2.30.1",
    "ng2-charts": "^6.0.1",
    "ng2-pdf-viewer": "^10.4.0",
    "raygun4js": "^3.1.3",
    "rxjs": "~7.5.0",
    "tinycolor2": "^1.6.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "~19.2.15",
    "@angular/compiler-cli": "^19.2.15",
    "@types/jasmine": "~4.0.0",
    "jasmine-core": "~4.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "^5.7.3"
  }
}